export const environment = {
  production: false,
  // apiUrl: "https://soulaca.onrender.com/api/",
  // site_url: "http://localhost:8081/api/",
  apiUrl : "https://soulaca.com/api/",
  site_url: "http://soulaca.com/#",
};
